module.exports = "/images/vendor/flag-icon-css/flags/4x3/lu.svg?c858787cf95b92f694dbe1d296a8a5d4";